module.exports = __webpack_public_path__ + "static/media/md-arrow-round-forward.90d74733.svg";